module.exports = __webpack_public_path__ + "static/img/box_1_2_bg.908190f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/box_1_2_bg.png
// module id = 9/3i
// module chunks = 1